import { styled, Tab, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs, {
	shouldForwardProp: (prop) =>
		prop !== 'indicatorBgColor' && prop !== 'dividerHeight',
})<{ indicatorBgColor?: string; dividerHeight?: number }>(
	({ theme, indicatorBgColor, dividerHeight = 1 }) => ({
		minHeight: 'unset',
		width: '100%',
		position: 'relative',

		'& .MuiTabs-flexContainer': {
			gap: 0,
		},

		'& .MuiTabs-indicator': {
			backgroundColor: indicatorBgColor ?? theme.palette.bewegt?.main,
			height: `${dividerHeight}px`,
			zIndex: 2,
		},

		'&::after': {
			content: '""',
			position: 'absolute',
			bottom: 0,
			left: 0,
			right: 0,
			height: `${dividerHeight}px`,
			backgroundColor: theme.palette.solutions?.[100],
			zIndex: 1,
		},
	})
);

export const StyledTab = styled(Tab)(({ theme }) => ({
	minHeight: 'unset',
	minWidth: 'unset',
	textTransform: 'none',
	...theme.typography.b2,

	color: theme.palette.solutions?.[600],

	'&.Mui-selected': {
		...theme.typography['b2-m'],
		color: theme.palette.primary.main,
		opacity: 1,
	},

	'&:hover:not(.Mui-selected)': {
		opacity: 0.7,
	},

	'&.Mui-disabled': {
		opacity: 0.3,
	},
}));
